var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"instant-search"},[_c('SearchBox',_vm._b({attrs:{"value":_vm.query},on:{"input":_vm.handleInput}},'SearchBox',_vm.$attrs,false)),_vm._v(" "),_c('SearchResults',{attrs:{"results":_vm.results}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }